import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter7() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">Building for the Future</p>
        <p className="chapter__paragraph">
          The eco-savvy elements of Miller’s Landing are paramount to the future of development.
          “One of the great challenges we face in building development is to make our buildings more
          environmentally friendly,” Wilkinson says. “Smart building technology like intelligent
          building management systems and IoT can help transform how building environmentals are
          measured and resources allocated to respond dynamically as occupancy and external
          environmental factors change throughout the day.”
        </p>
        <p className="chapter__paragraph">
          This means that everything is connected and monitored, so Miller’s Landing only uses
          energy as needed. “Whenever a space is not in use, enabling technology will allow
          management companies to control everything in an orchestrated set of applications,” Ilhan
          explains. “In a room-control system, we’re talking about heating and cooling, drawn
          curtains, lighting, and TV.” Across these disparate systems, power consumption is
          fine-tuned and optimized.
        </p>
      </section>
      <section>
        <PullQuote
          quote={
            'Smart building technology like intelligent building management systems and IoT can help transform how building environmentals are measured and resources allocated to respond dynamically as occupancy and external environmental factors change throughout the day.'
          }
          author={'Ken Wilkinson,'}
          source={'Layer 10'}
        />
      </section>
      <section className="chapter">
        <p className="chapter__paragraph">
          Using energy-efficient water and power solutions, such as solar power through the Douglas
          County Commercial Property Assessed Clean Energy, or C-PACE, financing program, Miller’s
          Landing is planning for the future. “The community is able to manage the consumption in a
          smart way,” Ilhan says.
        </p>
        <p className="chapter__paragraph">
          Technology systems also have a significant role to play in this dynamic allocation of
          scarce resources, Wilkinson says. Artificial intelligence capabilities can be used to
          determine the heating and cooling needs of a space (based on building occupancy and
          external environmental factors, not on a predetermined schedule) to the monitoring of
          building usage. And Intel-enabled technology provides an opportunity to “gamify”
          sustainability.
        </p>
      </section>
    </>
  );
}

export default Chapter7;
